import { render, staticRenderFns } from "./ProjectName.vue?vue&type=template&id=28d3b8ae&"
import script from "./ProjectName.vue?vue&type=script&lang=js&"
export * from "./ProjectName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports